module.exports = __webpack_public_path__ + "img/activities-19.ca1b287f.jpg";